import styled from 'styled-components';

import { Text } from 'features/common/components/Text';

export const ActiveRecipientRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 12px;
`;

export const ActiveRecipientLabel = styled.label`
	font-weight: 500;
	color: ${({ theme }) => theme.colors.black};
`;

export const DropdownWrap = styled.div`
	flex: 1;
	max-width: 280px;
`;

export const ActiveRecipientSelect = styled.select`
	width: 100%;
	height: 40px;
	padding: 0 12px;
	box-sizing: border-box;
	background-color: ${({ theme }) => theme.colors.whitePearl};
	border: 1px solid ${({ theme }) => theme.colors.lightGrey};
	border-radius: 8px;
	font-family: ${({ theme }) => theme.fonts.primary};
	font-size: 14px;
	color: ${({ theme }) => theme.colors.black};
	cursor: pointer;
	appearance: none;
	-webkit-appearance: none;
	background-image: linear-gradient(45deg, transparent 50%, ${({ theme }) => theme.colors.black} 50%),
		linear-gradient(135deg, ${({ theme }) => theme.colors.black} 50%, transparent 50%);
	background-position: calc(100% - 16px) center, calc(100% - 11px) center;
	background-size: 5px 5px, 5px 5px;
	background-repeat: no-repeat;
	padding-right: 28px;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.colors.greyBlue};
	}
`;

export const RecipientCard = styled.div`
	border-radius: 8px;
	background-color: ${({ theme }) => theme.colors.whitePearl};
	border: 1px solid ${({ theme }) => theme.colors.punchupOrange};
	padding: 10px 24px;
	display: flex;
	flex-direction: column;
	gap: 8px;

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		padding: 16px 18px;
	}
`;

export const RecipientHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const RecipientTitle = styled(Text)`
	font-weight: 500;
	font-size: 16px;
	line-height: 46px;
	margin: 0;
	color: ${({ theme }) => theme.colors.black};
`;

export const RemoveButton = styled.button`
	background: none;
	border: none;
	padding: 4px;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: ${({ theme }) => theme.colors.black};
	line-height: 0;
`;

export const NameRow = styled.div`
	display: flex;
	gap: 12px;
`;

export const SeatChips = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-top: 4px;
`;

export const EmptySeats = styled(Text)`
	color: ${({ theme }) => theme.colors.greyBlue};
	font-size: 13px;
	line-height: 18px;
	margin: 0;
	margin-top: 4px;
`;
